import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { IShapeModelProps } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/shape-model-props.interface';
import { IPictureModelProps } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/picture-model-props.interface';
import { IShapeNonVisualPropsData, IAttachmentData, STAttachmentClassify, STAttachmentShowType, DeltaOf } from '@tencent/slide-sdk-model';

/**
 * 附件
 */
export class AttachmentConverter {
    /**
     * 附件的sdk -> ui 映射
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(
        sdkData?: DeepReadonly<DeepPartial<IAttachmentData>>,
        uiData?: IShapeModelProps | IPictureModelProps,
    ): void {
        if (!uiData) {
            return;
        }
        if (sdkData) {
            uiData.attachment = {
                id: sdkData.id,
                objKey: sdkData.objKey,
                name: sdkData.name,
                size: sdkData.size,
                type: sdkData.type,
                classify: STAttachmentClassify[sdkData.classify || ''],
                showType: STAttachmentShowType[sdkData.showType || ''],
            };
            if (sdkData.posterInfo?.url) {
                uiData.attachment.posterInfo = sdkData.posterInfo;
            }
        }
    }

    /**
     * 附件的ui -> sdk 映射
     * @param uiData
     * @param sdkData
     */
    public static convertPartialDataFromUiToSdk(
        uiData: DeepReadonly<DeepPartial<IShapeModelProps | IPictureModelProps>>,
        sdkData: DeltaOf<IShapeNonVisualPropsData>,
    ): void {
        if (uiData.attachment) {
            sdkData.attachment = {
                id: uiData.attachment.id,
                objKey: uiData.attachment.objKey,
                name: uiData.attachment.name,
                size: uiData.attachment.size,
                type: uiData.attachment.type,
                classify: STAttachmentClassify[uiData.attachment.classify || ''] as unknown as STAttachmentClassify,
                showType: STAttachmentShowType[uiData.attachment.showType || ''] as unknown as STAttachmentShowType,
            };
            if (sdkData.attachment && uiData.attachment.posterInfo?.url) {
                sdkData.attachment.posterInfo = uiData.attachment.posterInfo;
            }
        }
    }
}
